/* Scroll rows in the PDP info list.

   Same resolution as the explore-links chips: an id, or a [data-anchor] on a
   section, taking the first candidate that is actually on screen — the theme
   renders some blocks twice (desktop and mobile copies) and only one of the
   pair is visible at any width. */
(function () {
  if (window.pdpInfoRowsInit) return;
  window.pdpInfoRowsInit = true;

  document.addEventListener('click', function (event) {
    var row = event.target.closest('[data-pdp-info-scroll]');
    if (!row) return;

    var href = row.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;

    var key = href.slice(1);
    if (!key) return;

    var candidates = document.querySelectorAll(
      '#' + CSS.escape(key) + ', [data-anchor="' + CSS.escape(key) + '"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].getClientRects().length) {
        event.preventDefault();
        candidates[i].scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
  });
})();
